import FigureId from '../Figure/FigureId';
import FigureColors from '../Figure/FigureColors';

export default class NextFigureLine {
    constructor() {

        this.id = FigureId.FigureLine;
        this.color = FigureColors.Red;
    }

    // implements pattern Template method.
    //
    getPositionOfFigure() {

        let item1 = { x: 1, y: 2 };
        let item2 = { x: 2, y: 2 };
        let item3 = { x: 3, y: 2 };
        let item4 = { x: 4, y: 2 };

        return [item1, item2, item3, item4];
    }

}


